import { render, staticRenderFns } from "./ThreadMng.vue?vue&type=template&id=71e2d99c&scoped=true&"
import script from "./ThreadMng.vue?vue&type=script&lang=js&"
export * from "./ThreadMng.vue?vue&type=script&lang=js&"
import style0 from "./ThreadMng.vue?vue&type=style&index=0&id=71e2d99c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2d99c",
  null
  
)

export default component.exports